/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Tour_Favorite_Projects_BodyInputs */



/**
* | output |
* | --- |
* | "Your personal project and your favorite projects stay here, so the work you return to most is never more than a click away." |
*
* @param {Onboarding_Tour_Favorite_Projects_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_tour_favorite_projects_body = /** @type {((inputs?: Onboarding_Tour_Favorite_Projects_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Tour_Favorite_Projects_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dein persönliches Projekt und deine favorisierten Projekte bleiben hier - die Arbeit, zu der du am häufigsten zurückkehrst, ist nie mehr als einen Klick entfernt.")
	return /** @type {LocalizedString} */ ("Your personal project and your favorite projects stay here, so the work you return to most is never more than a click away.")
});